"use client";

import {
	RiMicFill,
	RiMicLine,
	RiRainbowFill,
	RiRainbowLine,
	RiTicketFill,
	RiTicketLine,
	RiUserFill,
	RiUserLine,
} from "@remixicon/react";
import { cn } from "@workspace/ui/lib/utils";
import Link from "next/link";

// Navigation item type
export interface TopNavItem {
	title: string;
	url: string;
	isActive?: boolean;
}

interface NavItemProps {
	item: TopNavItem;
	variant: "mobile" | "desktop";
}

const iconMap = {
	festivals: {
		active: RiRainbowFill,
		inactive: RiRainbowLine,
	},
	shows: {
		active: RiTicketFill,
		inactive: RiTicketLine,
	},
	artists: {
		active: RiMicFill,
		inactive: RiMicLine,
	},
	profile: {
		active: RiUserFill,
		inactive: RiUserLine,
	},
};

export const NavItem = ({ item, variant }: NavItemProps) => {
	// Get the appropriate icon based on title and active state
	const iconKey = item.title.toLowerCase() as keyof typeof iconMap;
	const icons = iconMap[iconKey];
	const IconComponent = icons
		? item.isActive
			? icons.active
			: icons.inactive
		: RiTicketLine;

	return (
		<Link
			href={item.url}
			className={cn(
				"group flex h-9 items-center gap-2 rounded-xl transition-all duration-200",
				variant === "mobile" ? "px-3" : "px-4",
				item.isActive
					? "bg-muted/70 font-semibold text-foreground active:scale-95 active:bg-muted/90"
					: "text-muted-foreground hover:bg-muted/40 hover:text-foreground active:scale-95 active:bg-muted/60",
			)}
		>
			<IconComponent
				className={cn(
					"h-4 w-4",
					item.isActive
						? "text-foreground"
						: "text-muted-foreground group-hover:text-foreground",
				)}
			/>
			{variant === "desktop" && (
				<span className="font-medium text-sm">{item.title}</span>
			)}
		</Link>
	);
};
